import React from 'react';
import cn from 'classnames';
import SubscriptionSwitcher from 'subscriptions/SubscriptionSwitcher';
import Box from 'common/Box';
import Link from 'common/Link';
import InsuranceLink from 'insurance/Link';
import * as routes from 'app/routes';
import add_green_circle from 'common/img/add_green_circle.svg';
import styles from './Subscription.module.css';

export const SubscriptionScreen = ({ subId }) => {
  return (
    <div className={cn('Subscription', styles.wrapper)}>
      <SubscriptionSwitcher
        sprintSubId={subId}
        sprintRoute={routes.sprintSubscription}
        attRoute={routes.attSubscription}
        quickRoute={routes.quickSubscription}
      />
      <div className={styles.linkList}>
        <Link className={styles.subscriptionLink} to={routes.sprintAddData(subId)}>
          <Box>
            <img src={add_green_circle} />
            Add Data
          </Box>
        </Link>
        <InsuranceLink className={styles.subscriptionLink} sprintSubId={subId} />
      </div>
    </div>
  )
}

export default SubscriptionScreen;
